// extracted by mini-css-extract-plugin
export default {"container":"g81tuvrGNH9_BvDk_TxA","input":"AFX9wllDuFc5PBV7di5k"};